<script>

    export default {
        async mounted () {       
          this.loadEducators();
          this.courseModels = await this.$store.getters.getCourses  
        },
        data() {
            return {
                educators: [],
                filteredEducators: [],
                courseModels: [],
                filterLevels: [],
                filterCourses: [],
                levels: ['Elementary', 'Intermediate', 'High'],
                rawdata: ""
            }
        },          
        methods: {  
          filterEducators() {
            return this.educators.filter( e => {
              var filterLevels = this.filterLevels
              var filterCourses = this.filterCourses

              var intersection = this.filterCourses.filter(x => e.courseNames.includes(x));
              var courseFilterIntersects = (intersection.length != 0 || this.filterCourses.length == 0 )

              var levelFilterIntersects = true;

              if ( e.gradeLevels ){
                levelFilterIntersects = 
                  ( (filterLevels.includes("High") && e.gradeLevels.high) ||
                    (filterLevels.includes("Intermediate") && e.gradeLevels.middle) ||
                    (filterLevels.includes("Elementary") && e.gradeLevels.elementary)
                  ) ||
                  (filterLevels.length == 0 );
              } else {
                levelFilterIntersects = (filterLevels.length == 0);
              }

              var ok = (
                 levelFilterIntersects &&
                courseFilterIntersects )
              console.log("returning ok: " + ok)
              return ok;
            })
            //vm.$forceUpdate();
          },   
          loadEducators() {
            var ref = this.$firebase.ref('Educator/');
            ref.once('value', function(snapshot) {
              var educators = [];  
              snapshot.forEach(function(e) {
                  var item = e.val();
                  item.key = e.key;
                  educators.push(item);
              }); 
              this.rawdata = educators
            
              // remove incomplete profiles and map grade levels
              this.educators = educators.filter( e => e.profileUpdated )
                                        .map( e => ({...e, name: e.fName + " " + e.lName })) 
                                        .map( e => {
                                          var gradeLevels = []
                                          if ( e.gradeLevels ) {
                                            if(e.gradeLevels.elementary){gradeLevels.push('Elementary');}
                                            if(e.gradeLevels.middle){gradeLevels.push('Intermediate');}
                                            if(e.gradeLevels.high){gradeLevels.push('High');}
                                          }
                                          

                                          return {...e, levelString: gradeLevels.join(" / ")}
                                        })
                                        .map( e => {
                                          var courseNames = new Array()
                                          if ( e.courses ) {
                                            Object.keys(e.courses).forEach( courseKey => {
                                              var course = e.courses[courseKey]
                                              courseNames.push(course)
                                            })
                                          }

                                          return {...e, courseNames: courseNames}
                                        })
              this.filteredEducators = this.filterEducators()
            }.bind(this));
          }      
        }
        
    }
</script>

<template lang="pug">
.browse-educators-container
  .browse-educators
    #search-hdr.row
      .col.s12
        h5 BROWSE EDUCATORS
        //- a(@click="loadEducators()") load
        p.choose Choose from the list of educators in your area.
    .row.filter-container
      .filter-grades.col.s12.m12.l2
        br 
        | Filter by Grade Level 
        .level-check(v-for="level in levels")
          input(type="checkbox" v-model="filterLevels" :value="level" @click="loadEducators()")
          label {{level}}
      .filter-courses.col.s12.m12.l10
        br 
        | Filter by Course
        .course-check-container
          .course-check(v-for="course in courseModels")
            input(type="checkbox" v-model="filterCourses" :value="course" @click="loadEducators()")
            label {{course}}
    .row
      #search-div.col.s12
        table.striped#search-tbl
          thead#tbl-hdr
            tr
              th Name
              th School
              th Grade Level
              th Courses
          tbody
            tr(v-for="educator in filteredEducators")
              td
                p.tbl-cmp
                  router-link(:to="'/industry/viewEducator/' + educator.key") {{educator.name}}
              td {{educator.school}}
              td {{educator.levelString}}
              td
                .course(v-for="course in educator.courses") 
                  | {{course.courseName}} 
                  span(v-if="course.courseName == 'Other'") &nbsp;({{course.otherText}})

            


</template>

<style lang="sass" scoped>

.browse-educators-container
  text-align: center

.browse-educators
  margin: 0 auto
  width: 95% 
  text-align: left
 
.filter-container
  padding-bottom: 20px;


.level-check
  label
    padding-left: 5px
    
p.choose
  padding-bottom: 0px
  margin-bottom: 0px

#search-hdr
  margin-bottom: 0px !important;

.filter-container

.filter-grades
  float: left;

.filter-courses
  //float: left;
  // padding-left: 50px


.course-check-container
  height: auto;
  width: 100%;
  display: flex;
  flex-wrap: wrap;

.course-check
  postition: relative
  width: 180px;
  padding: 2px
  float: left
  margin: 1px
  height: 20px
  label
    padding-left: 3px
    position: relative
    float: left
    top: -3px
    left: 2px
  input
    position: relative
    float: left

input
  opacity: 100 !important
  position: relative !important
  pointer-events: all !important



/*****************************************/
//educator profile css
/*****************************************/

#educ-profile, #educ-curr 
  margin-top: 2em;
  padding: .5em;
  background-color: #fff;


#educ-curr h6 
    font-weight: normal;
    font-size: 20px;
    margin-bottom: 10px;


#educ-personal-info #name 
  margin: 0 !important;


#educator-intro 
  margin-top: 1em;
  padding: .5em;
  background-color: #fff;



#educator-intro h6 
  font-size: 20px;
  margin-bottom: 10px;
  font-weight: normal;


// @media screen and (max-width: 600px)
//   #right-col, #left-col {
//     padding: 0;
  


#company-img 
  padding: 0;

#name 
  margin-top: 0;


#search-hdr h5 
  padding-top: 1em;


#search-hdr p 
  padding-bottom: 1em;


.opps-container, .intro-container 
  padding: 0 1em 0 1em;


.input-div.opp-title 
  color: #000 !important;
  font-weight: normal !important;


.opp-title 
  color: #1589FF;
  font-weight: bold;


.opp-details 
  font-size: 14px;



</style>